export default __webpack_public_path__ + "static/media/srinagar6.9d40ad8a.jpg";